module.exports = "/images/man-2.png?f2bbd7da36c220d57ba6f8bef918616c";